/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { EtransportPdfReportDownloadDto } from '@well/delivery-libs/etransport/domain-model';

@Injectable({
  providedIn: 'root',
})
export class ETransportPdfResourceService extends  AbstractResourceService<null, null, null, null>{
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('eTransportNotificationUrl'));
  }

  downloadPdf(uuid : string,eTransportPdfDownloadReportDTO: EtransportPdfReportDownloadDto){
    const urlPdf = `${this.url}/download-pdf/${uuid}`

    return this.httpClient?.post(urlPdf, eTransportPdfDownloadReportDTO,{
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe((res: any) => {
        const contentDisposition = res.headers.get('content-disposition');
        const fileName = contentDisposition
          ? contentDisposition.replace('attachment; filename=', '').replace(/"/g, '')
          : null;

        const link = document.createElement('a');
        link.href = res.body ? window.URL?.createObjectURL(res.body) : '';
        link.download = fileName ? fileName : '';
        link.click();
      });
  }
}
